// token-invalidation (AUTH-LOGOUT-05): cross-tab logout sync (UX supplement only).
// The real fix is server-side token revocation; this just makes other open tabs
// react quickly when one tab logs out (or is forced out by a 401), instead of
// waiting for their next API call to fail.
//
// SSR-safe: BroadcastChannel is browser-only, so every entry point guards on it
// (via useBroadcastChannel, the shared low-level primitive).

export type AuthChannelMessage = { type: 'logout' };

export const useAuthChannel = () => {
    const channel = useBroadcastChannel<AuthChannelMessage>('codepresso-auth');

    /** Notify other tabs that this session logged out. Best-effort, never throws. */
    const postLogout = (): void => channel.postOnce({ type: 'logout' });

    /**
     * Listen for logout broadcasts from other tabs.
     * Returns an unsubscribe function (no-op when unsupported).
     */
    const subscribeLogout = (handler: () => void): (() => void) =>
        channel.subscribe((data) => {
            if (data?.type === 'logout') {
                handler();
            }
        });

    return { postLogout, subscribeLogout };
};
